import { memo } from 'react';
import { Outlet } from 'react-router-dom';

import { TestingEditorContainerBox } from './TestingEditorContainer.style';

export const TestingEditorContainer = memo(({ children }) => {
    return (
        <TestingEditorContainerBox>
            {children}
            <Outlet />
        </TestingEditorContainerBox>
    );
});
